import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useHideMenu } from '../hooks/useHideMenu';
import { RegistroUsuario } from '../components/registroUsuario';
import { getUsuarioStorage } from '../helpers/getUsuarioStorage';

export const Ingreso = () => {

    useHideMenu(true);
    const navigate = useNavigate();

    const [sesionActiva, setSesionActiva] = useState(false);

    const usuario = getUsuarioStorage();

    // const pantallas= usuario.pantallas ? usuario.pantallas.split(",") : [];


    useEffect(() => {
        // const usuario = getUsuarioStorage();
        if (usuario && usuario.uidUsuario) {
            navigate("/inicio", { replace: true });
        }
    }, [usuario, sesionActiva]);

    // Esta función se la pasamos al hijo
    const onLoginSuccess = () => {
        setSesionActiva(true);
    };

    return (

        < RegistroUsuario onLoginSuccess={onLoginSuccess} />

    )
}
